import styled from 'styled-components';

export const DesktopPickerWrapper = styled.label`
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-start;
  z-index: 100;
`;

export const DesktopLabel = styled.div`
  font-size: 15px;
  margin-bottom: 3px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  text-align: left;
`;
